import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { IconSet, IconSetsV, IconSetUnawareIcon, IconV } from "@/types/icons";
import { fold } from "fp-ts/Either";
import { array, unknown } from "io-ts";
import NotificationLogger from "@/lib/notifications/notifications";

export async function findIcons(params: {
  iconSetSlug?: string | null;
  searchTerm?: string | null;
  offset?: number | null;
  suggestions?: string[] | null;
}) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_find_icons",
      decoder: array(IconV),
      dataToPost: params
    }),
    fold(
      () => null,
      icons => icons
    )
  );
}

export async function getIconSets() {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_get_icon_sets",
      decoder: IconSetsV
    }),
    fold(
      () => null,
      data => data
    )
  );
}

export async function deleteIcon(id: number) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_delete_icon",
      decoder: unknown,
      dataToPost: {
        id
      }
    }),
    fold(
      () => false,
      () => true
    )
  );
}

export async function deleteIconSet(iconSetSlug: IconSet["slug"]) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_delete_icon_set",
      decoder: unknown,
      dataToPost: {
        iconSetSlug
      }
    }),
    fold(
      () => false,
      () => true
    )
  );
}

export async function uploadIcons(
  icons: IconSetUnawareIcon[],
  iconSet: IconSet
) {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_upload_icons",
      decoder: unknown,
      dataToPost: {
        icons,
        iconSet
      }
    }),
    fold(
      () => false,
      () => true
    )
  );
}

export async function exportIconSet(iconSetSlug: IconSet["slug"]) {
  const baseUrl = window.Breakdance.restUrl;
  const nonce = window.Breakdance.restNonce;
  const url = `${baseUrl}/icons/export?_wpnonce=${nonce}&icon_set_slug=${iconSetSlug}`;

  const response = await fetch(url);

  if (!response.ok) {
    const isJson = response.headers
      .get("Content-Type")
      ?.startsWith("application/json");

    if (isJson) {
      const data = await response.json();
      NotificationLogger.log.errorMessage(data.message);
    } else {
      NotificationLogger.log.errorMessage("Failed to export icon set.");
      console.log(response);
    }

    return;
  }

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = downloadUrl;
  a.download = `${iconSetSlug}.zip`;
  document.body.appendChild(a);
  a.click();

  window.URL.revokeObjectURL(downloadUrl);
  document.body.removeChild(a);
}
